import { Reveal } from "@/components/motion";
import ButtonLink from "@/components/ButtonLink";

const CTABand = ({
  title = "Book en indledende samtale",
  sub = "Book en uforpligtende indledende samtale, hvor vi taler om din situation, hvad du gerne vil arbejde med, og hvordan et individuelt neurofeedbackforløb kan se ud.",
  label = "Næste skridt",
  showMethodLink = true,
  ctaLabel = "Udforsk metoden",
  ctaTo = "/neurofeedback",
  ctaTestId = "cta-band-method-btn",
}) => (
  <section data-testid="cta-band" className="bg-obsidian text-[#F5F5F0]">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-muted">{label}</p>
        <h2 className="mt-6 max-w-3xl font-serif text-4xl leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
          {title}
        </h2>
        <p className="mt-6 max-w-xl leading-relaxed text-[#A3A299]">{sub}</p>
        {showMethodLink && (
          <div className="mt-10 flex flex-wrap gap-4">
            <ButtonLink to={ctaTo} variant="outlineLight" testId={ctaTestId}>
              {ctaLabel}
            </ButtonLink>
          </div>
        )}
      </Reveal>
    </div>
  </section>
);

export default CTABand;
